export enum TangentType {
    type1 = "TYPE1",
    type2 = "TYPE2"
}